
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 5H4c-.5 0-.5.5 0 1l5 5s1.9 2 3 2 3-2 3-2l5-5c.5-.5.5-1 0-1z"}}),_c('path',{attrs:{"d":"M20 7l-5 5s-1.9 2-3 2-3-2-3-2L4 7c-.4-.3-1-.3-1 0v10c0 .5.3 1 .9 1H20c.5 0 1-.3 1-.9V7c0-.3-.6-.3-1 0z"}})])
          )
        }
      }
    